"use strict";

import { googleSheets, IS_PRODUCTION } from "../../_js/common/_variables";
import { sanitize } from "../../_js/common/_util";

export default class Model {
    constructor() {
        const self = this;

        self.companyModel = [];
        self.areaOfBusinessModel = [];
        self.overseasPresenceModel = [];
        self.cableModel = [];
        self.countriesModel = [];
        self.regionsModel = [];
    }

    getData(gid, fn) {
        let _gid = gid == undefined ? googleSheets.company : gid;
        let _url = `https://docs.google.com/spreadsheets/d/e/${googleSheets.spreadsheetID}/pub?gid=${_gid}&single=true&output=csv`;

        Papa.parse(_url, {
            download: true,
            delimiter: ",",
            worker: true,
            complete: function (res) {
                fn(res);
            },
            error: function (e) {
                console.error(e);
            },
        });
    }

    getPosInArr(arr, param) {
        for (let i = 0, l = arr.length; i < l; i++) {
            for (let j = 0, m = arr[i].length; j < m; j++) {
                if (sanitize(arr[i][j]) == param) {
                    return i;
                }
            }
        }
    }
}
